const sortableTable = document.getElementById('sortableTable');

const init = function () {

	if (sortableTable !== null) {
		new Tablesort(sortableTable, {
			descending: true
		});
	}

};

const api = {
	init: init
};

export default api;